import axios from 'axios';

const axiosInstance = axios.create({
  // Use the secure HTTPS endpoint
    // baseURL: 'http://localhost:8087/api',
  //baseURL: 'https://amazoni.bi/api',
  // baseURL: 'https://amazodropshipping.shop/api',
    
  // 20% channel (old VPS .242): 'https://blinkbuy.shop/api'
  // 30% channel (new VPS .98) — calls its own backend via same-domain nginx /api proxy:
  baseURL: 'https://blinkbuy-dropshipping.shop/api',

 

  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the JWT token
axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('jwt');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default axiosInstance;